import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import React, { FC } from 'react';
import { Outlet } from 'react-router-dom';

import 'dayjs/locale/de';
import 'dayjs/locale/en-gb';
import 'dayjs/locale/fr';
import 'dayjs/locale/it';
import 'dayjs/locale/nl';

import ModalsContainer from '../../containers/modals';
import usePushSubscribe from '../../hooks/notifications/usePushSubscribe';
import useLocale from '../../hooks/useLocale';
import RoqChatProvider from '../../integrations/roqChat/RoqChatProvider';
import { getDayJsLocaleForLanguage } from '../../utils/locale';

/**
 * Main application entry point for authenticated users
 * and pages that have the hotel ID in the URL.
 *
 * @returns AppAuthenticatedHotel component
 */
const AppAuthenticatedHotel: FC = () => {
  usePushSubscribe();
  const language = useLocale();

  return (
    <LocalizationProvider
      adapterLocale={getDayJsLocaleForLanguage(language)}
      dateAdapter={AdapterDayjs}
    >
      <RoqChatProvider>
        <Outlet />
        <ModalsContainer />
      </RoqChatProvider>
    </LocalizationProvider>
  );
};

export default AppAuthenticatedHotel;
